export default __webpack_public_path__ + "assets/e6fbb6ccc9ec23bfd57cf222db76ee4b.png";